import { apiClient } from './authService';

// REST API over the existing Charge model (charges fixes: personnel, loyer, ...).
const chargeService = {
  // Returns a plain array (the API is paginated; unwrap `results`).
  getAll: async () => {
    const res = await apiClient.get('charges/');
    return Array.isArray(res.data) ? res.data : (res.data.results || []);
  },

  create: async (data) => {
    const res = await apiClient.post('charges/', data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await apiClient.patch(`charges/${id}/`, data);
    return res.data;
  },

  remove: async (id) => {
    await apiClient.delete(`charges/${id}/`);
  },
};

export default chargeService;
